import { render, staticRenderFns } from "./CustomCheckbox.vue?vue&type=template&id=ba0161b0&scoped=true&"
import script from "./CustomCheckbox.vue?vue&type=script&lang=js&"
export * from "./CustomCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./CustomCheckbox.vue?vue&type=style&index=0&id=ba0161b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0161b0",
  null
  
)

export default component.exports